var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 mt-5"},[_c('FullCalendar',{staticClass:"demo-app-calendar",attrs:{"options":_vm.calendarOptions},scopedSlots:_vm._u([{key:"eventContent",fn:function(arg){return [_c('b',[_vm._v(_vm._s(arg.timeText)+"  ")]),_c('i',[_vm._v(_vm._s(arg.event.title))])]}}])})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }